"use client";
import {
  useTabStore
} from "../__chunks/CQMDBRG5.js";
import {
  TabContextProvider
} from "../__chunks/32VQXIYR.js";
import "../__chunks/7GBW5FLS.js";
import "../__chunks/Y6GYTNQ2.js";
import "../__chunks/3D6OCOHF.js";
import "../__chunks/MADQZZRL.js";
import "../__chunks/5M6RSQEC.js";
import "../__chunks/EKQEJRUF.js";
import "../__chunks/6O5OEQGF.js";
import "../__chunks/XM66DUTO.js";
import "../__chunks/4R3V3JGP.js";

// src/tab/tab-provider.tsx
import { jsx } from "react/jsx-runtime";
function TabProvider(props = {}) {
  const store = useTabStore(props);
  return /* @__PURE__ */ jsx(TabContextProvider, { value: store, children: props.children });
}
export {
  TabProvider
};
